import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, Typography } from '@material-ui/core';
import { Column, Options, Action } from 'material-table';

import { TableEmpty } from '../../../../shared/components/TableEmpty';
import { TableLoading } from '../../../../shared/components/TableLoading';
import { TableCommon } from '../../../../shared/components/TableCommon';
import { ClassificationModel, classificationModelInitial } from '../../../../Models/ClassificationModel';
import { SearchStatus } from '../../../../shared/enum/SearchStatus';
import ClassificationService from '../../../../Services/ClassificationService';
import { BasicPage } from '../../../../shared/components/BasicPage';
import { ClassificationFilterFields } from '../components/ClassificationFilterFields';
import { RevisionContext } from '../RevisionContext';
import { getTableColumn } from '../../../../shared/operators';
import { ReviewDialog } from '../components/ReviewDialog';
import NewsCategorization from '../../components/NewsCategorization';
import NewsData from '../../components/NewsData';
import { NewsContext } from '../../NewsContext';
import NewsService from '../../../../Services/NewsService';
import { HomeContext } from '../../../Home/HomeContext';
import { NewsModel } from '../../../../Models/NewsModel';
import { AuthContext } from '../../../Authentication/AuthContext';
import { ErrorStatus } from '../../../../shared/enum/ErrorStatus';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import { ClassificationStatus } from '../../enum/ClassificationStatus';
import { RestoreClassification } from '../../components/RestoreClassification';
import { NewsLoadingContext } from '../../NewsLoadingContext';
import { LoadingStatus } from '../../enum/LoadingStatus';

export function ReportRevision() {

    const revisionContext = React.useContext(RevisionContext);
    const newsContext = React.useContext(NewsContext);
    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);
    const authContext = React.useContext(AuthContext);

    const [classificationResult, setClassificationResult] = React.useState<ClassificationModel[]>([]);
    const [totalClassificationNumber, setTotalClassificationNumber] = React.useState<number | null>(null);

    const [isConfirmDeletionOfClassificationDialogOpen, setIsConfirmDeletionOfClassificationDialogOpen] = React.useState(false);
    const [isReviewClassificationModalOpen, setIsReviewClassificationModalOpen] = React.useState(false);
    const [newsId, setNewsId] = React.useState(-1);

    const [callSearch, setCallSearch] = React.useState<boolean>(false);

    const [hasNotError, setHasNotError] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (isReviewClassificationModalOpen && newsId > 0) {
            fetchNews();
        }
    }, [newsId, isReviewClassificationModalOpen]);

    React.useEffect(() => {
        if (newsContext.errorDataStatus == ErrorStatus.HAS_NOT_ERROR && newsContext.errorCategorizationStatus == ErrorStatus.HAS_NOT_ERROR) {
            setHasNotError(true);
        }
        else if (
            (newsContext.errorDataStatus == ErrorStatus.HAS_ERROR ||
                newsContext.errorCategorizationStatus == ErrorStatus.HAS_ERROR) &&
                newsContext.errorAtLeastOneCategorizationStatus !== ErrorStatus.HAS_ERROR) {
            
            homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    }, [newsContext.errorDataStatus, newsContext.errorCategorizationStatus]);

    React.useEffect(() => {
        if (hasNotError) {
            saveClassification();
            setHasNotError(false);
        }
    }, [hasNotError]);

    const fetchNews = () => {
        newsLoadingContext.setClassificationLoading(LoadingStatus.LOADING);

        if (newsId) {
            NewsService.newsService(0)
                .get(newsId)
                .then((res: AxiosResponse) => {
                    const news = res.data as NewsModel;
                    newsContext.setNews(news);
                    fetchEditClassification(news?.classificationId || 0);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError('', error);
                    newsLoadingContext.setClassificationLoading(LoadingStatus.ERROR);
                });
        }
    };

    const closeModalAndFetchNews = () =>{
        setIsReviewClassificationModalOpen(false); 
        searchClassifications();
    };

    const fetchEditClassification = (classificationId: number) => {
        ClassificationService.classificationService()
            .get(classificationId)
            .then((res: AxiosResponse) => {
                newsContext.setClassification(res.data);
                newsLoadingContext.setClassificationLoading(LoadingStatus.DONE);
            })
            .catch((error: AxiosError) => {
                homeContext.showError('', error);
                newsLoadingContext.setClassificationLoading(LoadingStatus.ERROR);
            });
    };

    const handleDiscard = () => {
        setIsReviewClassificationModalOpen(false); 
        setNewsId(-1); 
        newsContext.setClassification(classificationModelInitial);
    };

    const handleClickSaveModal = () => {
        newsContext.setErrorDataStatus(ErrorStatus.RUN);
        newsContext.setErrorCategorizationStatus(ErrorStatus.RUN);
        newsContext.setErrorAtLeastOneCategorizationStatus(ErrorStatus.RUN);
    };

    const handleClickDeleteModal = () => {
        homeContext.setOpenLoadingDialog(true);

        ClassificationService.deleteBatch([newsContext.classification.id])
            .then(() => {
                homeContext.setOpenLoadingDialog(false);
                homeContext.showSuccess('A classificação da notícia foi excluída com sucesso!');

                newsContext.setClassification(classificationModelInitial);
                setCallSearch(true);
                setIsReviewClassificationModalOpen(false);
                setIsConfirmDeletionOfClassificationDialogOpen(false);
                
            })
            .catch((error: AxiosError) => {
                homeContext.setOpenLoadingDialog(false);
                setIsConfirmDeletionOfClassificationDialogOpen(false);
                homeContext.showError('Erro ao excluir classificação. <br/>', error);
            });
    };

    const saveClassification = () => {
        if (newsContext.classification.id > 0) {
            homeContext.setOpenLoadingDialog(true);
            
            const classificationData = newsContext.classification;
            classificationData.userCodeMetric = authContext.login.user.codeMetric;
            classificationData.userId = authContext.login.user.id;
            classificationData.vehicle = newsContext.vehicle;
            classificationData.clientCodeMetric = newsContext.news.clientCodeMetric;  

            ClassificationService.classificationService()
                .update(classificationData)
                .then(() => {
                    homeContext.setOpenLoadingDialog(false);
                    finishSave();
                })
                .catch((error: AxiosError) => {
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showError('Erro ao atualizar classificação. <br/>', error);
                });
        }
    };
    
    const finishSave = () => {
        homeContext.showSuccess('A classificação da notícia foi alterada com sucesso!');

        setIsReviewClassificationModalOpen(false);
        setCallSearch(true);
        newsContext.setClassification(classificationModelInitial);
    };

    const searchClassifications = () => {
        revisionContext.setSearchStatus(SearchStatus.LOADING);

        ClassificationService
            .getClassificationsByFilters(revisionContext.filterClassification)
            .then((res: AxiosResponse) =>{
                setClassificationResult(res.data);
                if (res.data.length > 0) {
                    setTotalClassificationNumber(res.data.length);
                    revisionContext.setSearchStatus(SearchStatus.RESULT);
                }
                else
                    revisionContext.setSearchStatus(SearchStatus.EMPTY);
            })
            .catch((error: AxiosError) => {
                revisionContext.setSearchStatus(SearchStatus.INITIAL);
                homeContext.showError('Ops... Ocorreu um erro e não foi possível carregar as classificações.' +
                    'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
            });
    };

    const tableColumns: Column<ClassificationModel>[] = [
        {
            title: 'Título da publicação',
            field: 'publicationTitle',
            type: 'string',
            align: 'left',
            cellStyle: {width: '40%'},
            render: rowData => getTitleLink(rowData)
        },        
        getTableColumn('ID', 'id', 'numeric', 'left', {width: '10%'}),
        getTableColumn('ID do metric', 'metricId', 'string', 'left', {width: '10%'}),
        getTableColumn('Veículo', 'vehicleNomenclature', 'string', 'left', {width: '20%'}),
        getTableColumn('Qtd. de categorias', 'numberOfCategories', 'numeric', 'left', {width: '10%'}),
        getTableColumn('Data de classificação', 'includeDate', 'date', 'left', {width: '10%'}, 'desc')
    ];

    const tableActions: Action<any>[] = [
        {
            icon: 'edit_note',
            iconProps: { style: { fontSize: '24px' } },
            tooltip: 'Revisar',
            onClick: (_, rowData) => { handleReviewButton(rowData); }
        }
    ];

    const tableOptions: Options<ClassificationModel> = {
        filtering: true,
        toolbar: false,
        showTitle: false,
        actionsColumnIndex: -1,
        pageSizeOptions: [10, 15, 20],
        pageSize: 15,
        rowStyle: rowData => ({
            color: (rowData.status == ClassificationStatus.REMOVED) ? theme.palette.text.disabled : theme.palette.text.primary
        }),
    };

    const handleReviewButton = (classification: ClassificationModel) => {
        setNewsId(classification.newsId);
        setIsReviewClassificationModalOpen(true);
    };

    const getTitleLink = (rowData: ClassificationModel) => {
        if (rowData.status != ClassificationStatus.REMOVED)
            return (<a href={rowData.clipperLink} target='_blank' rel="noreferrer noopener">{rowData.publicationTitle}</a>);
        else
            return rowData.publicationTitle;
    };

    const getResultTable = () => {
        if (revisionContext.searchStatus == SearchStatus.LOADING) {
            return (
                <Grid item xs={12}>
                    <TableLoading displayText='Buscando classificações...' />
                </Grid>
            );
        }
        else if (revisionContext.searchStatus == SearchStatus.RESULT) {
            return (
                <>
                    <Grid item xs={12}>
                        <Typography variant="body1">{totalClassificationNumber} classificações encontradas</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TableCommon
                            tableData={classificationResult}
                            tableColumns={tableColumns}
                            emptyDataSourceMessage='Nenhuma classificação encontrada'
                            tableActions={tableActions}
                            extraOptions={tableOptions} />
                    </Grid>
                </>
            );
        }
        else if (revisionContext.searchStatus == SearchStatus.EMPTY) {
            return (
                <Grid item xs={12}>
                    <TableEmpty displayText='Nenhuma classificação encontrada' />
                </Grid>
            );
        }
    };

    const getModalReviewInput = () => {
        return (
            <>
                <RestoreClassification
                    classificationStatus={newsContext.classification.status}
                    onRestore={closeModalAndFetchNews} 
                    />
                <Grid container direction="column" spacing={6}>
                    <Grid item>
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Typography variant="h5">Dados da publicação</Typography>
                            </Grid>
                            <Grid item>
                                <NewsData />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Typography variant="h5">Categorização da publicação</Typography>
                            </Grid>
                            <Grid item>
                                <NewsCategorization /> 
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        );
    };
    
    return(
        <>
            <BasicPage
                title="Revisão de relatório"
                subtitle="Utilize os filtros abaixo para encontrar as notícias que deseja revisar">
                <>
                    <ClassificationFilterFields
                        callbackSearch={searchClassifications}
                        callSearch={callSearch}
                        setCallSearch={setCallSearch} />
                    { getResultTable() }
                </>
            </BasicPage>
            <ReviewDialog
                open={isReviewClassificationModalOpen}
                handleDeleteButton={ () => setIsConfirmDeletionOfClassificationDialogOpen(true) }
                handleDiscardButton={ () => handleDiscard() }
                handleConfirmButton={ () => handleClickSaveModal() }>
                {getModalReviewInput()}
            </ReviewDialog>
            <BasicConfirmDialog
                title="Remover classificação?"
                description="Você removerá esta classificação, mas, poderá recuperá-la mais tarde se desejar."
                handleFirstButton={() => handleClickDeleteModal()}
                handleSecondButton={() => setIsConfirmDeletionOfClassificationDialogOpen(false)}
                textFirstButton="Remover"
                textSecondButton="Voltar"
                open={isConfirmDeletionOfClassificationDialogOpen}
                reverseButtons={true}
                cssProperties={{ justifyButtons: 'flex-end' }} />
        </>
    );
}